<template>
    <div class="login">
        <div class="login-form">
            <a-button type="link" class="back-button" @click="onBack">
                <i class="fa fa-arrow-left fa-6" aria-hidden="true"></i>
            </a-button>

            <h1>Подтверждение</h1>

            <p class="subtitle">{{ currentMessage }}</p>

            <div v-if="blockStatusUser" class="error-message">
                <span>
                    <span>{{ blockMsgUser }}</span>
                    :
                    <timer
                        :initial-seconds="blockTimeUser"
                        format="mm:ss"
                        @stop="onTimerEmitStop"
                    />
                </span>
            </div>
            <div
                v-else-if="counterButtonSendContinue < 5 && counterButtonSendContinue !== 0"
                class="error-message"
            >
                {{ `${errorMessageUser}: ${counterButtonSendContinue}` }}
            </div>

            <!-- <h3>Введите код из SMS</h3> -->

            <div class="pin-inputs">
                <a-input
                    v-for="(digit, index) in otp"
                    :key="index"
                    ref="otpInputs"
                    v-model:value="otp[index]"
                    class="pin-digit"
                    :maxlength="1"
                    :disabled="blockStatusUser"
                    @input="onInput(index)"
                    @keydown="handleKeyDown(index, $event)"
                    @focus="onFocus(index)"
                />
            </div>

            <div v-if="currentTimer > 0 && !blockStatusUser" class="timer">
                Ожидание: {{ currentTimer }} с.
            </div>

            <div class="additional-buttons">
                <a-button
                    type="link"
                    :disabled="currentTimer > 0 || blockStatusUser"
                    @click="onResendCode"
                >
                    Отправить код повторно
                </a-button>
            </div>

            <a-button
                type="primary"
                class="login-btn"
                :disabled="!isOtpComplete || blockStatusUser"
                @click="onSubmit"
            >
                Подтвердить
            </a-button>
        </div>
        <app-version />
    </div>
</template>

<script>
import { showErrorNotification, RouterConfig } from '@/utils';
import Timer from '@/components/Timer.vue';
import AppVersion from '@/components/authorization/AppVersion.vue';

export default {
    name: 'AuthorizationForgotVerifyBySms',
    components: {
        Timer,
        AppVersion,
    },
    props: {
        message: {
            type: String,
            default: 'Мы отправили код на номер',
        },
        resendCooldownSeconds: {
            type: Number,
            default: 60,
        },
        phone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            otp: ['', '', '', ''],
            currentMessage: this.message, // Используем значение из props по умолчанию
            currentTimer: this.resendCooldownSeconds, // Используем значение из props по умолчанию
            currentPhone: this.phone,
            timerInterval: null,
            /**
             * Флаг вывода контейнера с ошибкой
             */
            // errorStatusUser: false,
            /**
             * Текст ошибки при невернном вводе пин-код
             */
            errorMessageUser: 'Неверный код. Осталось попыток',
            /**
             * TODO
             * "Статус блокировки"
             * заблокирован ли пользователь
             */
            blockStatusUser: false,
            /**
             * TODO
             * "Время блокировки"
             * оставшееся время блокировки
             */
            blockTimeUser: 300, // TODO "Время блокировки"
            /**
             * TODO
             * "Текст блокировки"
             * выводим текст для пользователя
             */
            blockMsgUser: 'Вы исчерпали количество попыток. Подождите',
            /**
             * TODO
             * "Счетчик количества попыток отправки пин-кода"
             * Кнопка "Продолжить"
             * оставшееся количество попыток отправки пин-кода до блокировки по кнопке
             */
            counterButtonSendContinue: 5,
            /**
             * TODO
             * "Счетчик количества попыток повторной отправки пин-кода"
             * Кнопка "Отправить код повторно"
             * оставшееся количество попыток повторной отправки пин-кода по кнопке
             */
            counterButtonSendRepeat: 2,
        };
    },
    computed: {
        isOtpComplete() {
            return this.otp.every((digit) => digit !== '');
        },
    },
    created() {
        if (RouterConfig.forgot.name in localStorage) {
            try {
                const session = JSON.parse(localStorage[RouterConfig.forgot.name]);
                this.currentMessage = `${this.currentMessage}: ${session.phone}`; // TODO заменить this.currentMessage на message
                this.currentTimer = session.resendCooldownSeconds || this.resendCooldownSeconds;
                this.currentPhone = session.phone;
            } catch (error) {
                console.error(error);
            }
        }
    },
    mounted() {
        this.startTimer();
        this.$nextTick(() => {
            if (this.$refs.otpInputs && this.$refs.otpInputs[0]) {
                this.$refs.otpInputs[0].focus();
            }
        });

        // При монтировании компонента сразу отправляем код повторно
        // this.onResendCode();
    },
    watch: {
        otp: {
            handler() {
                if (!this.isOtpComplete || this.blockStatusUser) {
                    return;
                }

                this.onSubmit();
            },
            deep: true,
        },
    },
    methods: {
        onInput(index) {
            if (this.blockStatusUser) {
                this.otp = ['', '', '', ''];
                return;
            }

            if (!/^\d$/.test(this.otp[index])) {
                this.otp[index] = '';
                return;
            }

            if (index < 3 && this.otp[index] !== '') {
                this.$nextTick(() => {
                    if (this.$refs.otpInputs[index + 1]) {
                        this.$refs.otpInputs[index + 1].focus();
                    }
                });
            }
        },
        handleKeyDown(index, event) {
            const { key } = event;

            if (key === 'Delete' || key === 'Backspace') {
                this.onDelete(index);
                event.preventDefault();
            } else if (key === 'ArrowRight' && index < 3) {
                if (this.$refs.otpInputs[index + 1]) {
                    this.$refs.otpInputs[index + 1].focus();
                }
                event.preventDefault();
            } else if (key === 'ArrowLeft' && index > 0) {
                if (this.$refs.otpInputs[index - 1]) {
                    this.$refs.otpInputs[index - 1].focus();
                }
                event.preventDefault();
            }
        },
        onDelete(index) {
            if (this.otp[index] === '') {
                if (index > 0) {
                    this.otp[index - 1] = '';
                    if (this.$refs.otpInputs[index - 1]) {
                        this.$refs.otpInputs[index - 1].focus();
                    }
                }
            } else {
                this.otp[index] = '';
            }
        },
        onFocus(index) {
            this.$nextTick(() => {
                if (this.$refs.otpInputs[index]) {
                    this.$refs.otpInputs[index].select();
                }
            });
        },
        startTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }

            this.timerInterval = setInterval(() => {
                if (this.currentTimer > 0) {
                    this.currentTimer -= 1;
                } else {
                    clearInterval(this.timerInterval);
                    this.timerInterval = null;
                }
            }, 1000);
        },
        resetTimer(seconds) {
            this.currentTimer = seconds !== undefined ? seconds : this.resendCooldownSeconds;
            this.startTimer();
        },
        async onSubmit() {
            if (!this.isOtpComplete) {
                return;
            }

            const otpCode = this.otp.join('');

            try {
                await this.$http.post('/v2/auth/forgot/verify', {
                    code: otpCode,
                });

                this.$router.push({ name: RouterConfig.forgotPasswordUp.name });
            } catch (error) {
                this.clearPinCodeInputs();
                if (error.response.data.msg) {
                    if (this.counterButtonSendContinue >= 0) {
                        this.counterButtonSendContinue -= 1;
                    }

                    if (this.counterButtonSendContinue <= 0) {
                        this.blockStatusUser = true;
                    }
                }
            }
        },
        async onResendCode() {
            const { deviceId, staffId } = localStorage;

            try {
                await this.$http.post('/v2/auth/forgot/resend', {
                    deviceId,
                    bySMS: true,
                    userId: staffId,
                });
            } catch (error) {
                showErrorNotification(error.response.data.msg, 5000);
            }

            this.clearPinCodeInputs();
            this.resetTimer();
        },
        clearPinCodeInputs() {
            this.otp = ['', '', '', ''];
            this.$nextTick(() => {
                if (this.$refs.otpInputs[0]) {
                    this.$refs.otpInputs[0].focus();
                }
            });
        },
        onBack() {
            this.$router.go(-1);
        },
        onTimerEmitStop() {
            this.currentTimer = 0;
            this.blockStatusUser = false;
            this.counterButtonSendContinue = 5;
            this.counterButtonSendRepeat = 2;
            this.clearPinCodeInputs();
        },
    },
    beforeUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    },
};
</script>

<style lang="scss" scoped>
.login {
    background: url("/images/login-wall.jpg") center center / cover no-repeat rgb(255, 255, 255);
    height: 100%;
    display: flex;
}

.login-form {
    position: relative;
    margin: auto;
    max-width: 460px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 26px;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    h1 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: center;
    }

    .subtitle {
        color: #666;
        font-size: 14px;
        margin-bottom: 8px;
        text-align: center;
        padding: 0 30px;
    }

    h3 {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
        text-align: center;
    }

    .pin-inputs {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-top: 8px;
        margin-bottom: 4px;

        .pin-digit {
            width: 50px;
            height: 50px;
            text-align: center;
            font-size: 20px;
            border-radius: 8px;
            border: 1px solid #d9d9d9;

            &:focus {
                border-color: #83b274;
                box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
            }
        }
    }

    .timer {
        font-size: 14px;
        margin-bottom: 15px;
        text-align: center;
        color: #666;
    }

    .additional-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 15px;
        margin-bottom: 18px;

        .ant-btn {
            text-align: center;
            padding: 0;
            width: fit-content;
            height: auto;
            text-decoration: none;
            color: #83b274;
            font-size: 14px;
            margin: 0 auto;
            border: none;
            background-color: transparent;
            box-shadow: none;

            &:disabled,
            &[disabled] {
                pointer-events: none;
                opacity: 0.5;
            }

            &:hover {
                color: #74b85d;
            }
        }
    }

    .login-btn {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-top: auto;

        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 0;
        font-size: 16px;

        width: 32px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #83b274;
        color: #83b274;
        box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);

        &:hover {
            color: #74b85d;
            border-color: #74b85d;
            box-shadow: 0 0 0 2px rgba(116, 184, 93, 0.4);
        }
    }

    .error-message {
        color: #ff4d4f;
        font-size: 12px;
        margin-bottom: 15px;
        text-align: left;
        max-width: 100%;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }
}
</style>
